import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { BxBadgeComponent, BxCardComponent, BxCardHeaderComponent, dotIcon, injectBxIcons } from '@beyonnex/bx-angular-ui';
import { TranslatePipe } from '@ngx-translate/core';
import { LocalizationService } from '../../../services/localization/localization.service';
import { formatDateAtTime } from '../../../utils/utils';
import { DeviceDetailsStore } from '../device-details.store';

@Component({
  selector: 'bxi-building-heating-disruption',
  imports: [BxCardComponent, BxCardHeaderComponent, BxBadgeComponent, TranslatePipe],
  templateUrl: './building-heating-disruption.component.html',
  host: { class: 'block' },
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BuildingHeatingDisruptionComponent {
  private readonly localization = inject(LocalizationService);

  protected readonly summary = toSignal(inject(DeviceDetailsStore).heatingDisruptionSummary$);

  protected readonly formatDateAtTime = (input: string): string => formatDateAtTime(input, this.localization.getLanguage());

  constructor() {
    injectBxIcons([dotIcon]);
  }
}
